/**
 * S17 (Deep-Code-Analysis 2026-07-01 §1) — safe-href gate for model/tool-supplied
 * reference URLs rendered by Copilot cards.
 *
 * The approval card renders references from the untrusted `data-approval-pending`
 * SSE part straight into `<a href>`; a `javascript:`/`data:` URL would execute in
 * the customer page on click. This helper is the single sanitization home for any
 * model-supplied href sink.
 *
 * A URL is safe iff EXACTLY one of:
 *   - `new URL(url)` parses AND its protocol is `http:` or `https:` (WHATWG URL
 *     parsing normalizes case/whitespace tricks — `JaVaScRiPt:` and
 *     `'java\nscript:'` both parse with protocol `javascript:` and are rejected);
 *   - `new URL(url)` threw (relative input) AND the string starts with `/`, its
 *     second character is neither `/` nor `\`, and it contains no `\` anywhere
 *     (the M06 isSafeRelativePath rule — reject, never normalize);
 *   - it starts with `#` (fragment link).
 *
 * Everything else (protocol-relative `//`, `javascript:`, `data:`, `vbscript:`,
 * `blob:`, empty string, undefined) is unsafe.
 *
 * @returns the input unchanged iff it is a safe href, else `undefined`.
 */
export function safeRefHref(url) {
    if (url === undefined)
        return undefined;
    try {
        const parsed = new URL(url);
        return parsed.protocol === 'http:' || parsed.protocol === 'https:'
            ? url
            : undefined;
    }
    catch {
        // Relative input — apply the M06 isSafeRelativePath rule.
        if (url.startsWith('#'))
            return url;
        if (url.startsWith('/') &&
            url[1] !== '/' &&
            url[1] !== '\\' &&
            !url.includes('\\')) {
            return url;
        }
        return undefined;
    }
}
//# sourceMappingURL=safe-url.js.map